import React from 'react';
import styles from './styles.module.scss'

interface VideoBoxProps {
  id: string;
  videoUrl: string;
  isLogicMaker?: boolean;
  pos? : any;
  size?: any;
  onClick?: (e: React.MouseEvent) => void;
  isDragging?: boolean
}

export const YoutubeVideo: React.FC<VideoBoxProps> = ({
  size,
  videoUrl,
  isLogicMaker,
  pos,
  isDragging,
  onClick
}) => {
  // Extrai o ID do vídeo de diferentes formatos de URL
  const getYouTubeId = (url: string): string | null => {
    try {
      const u = new URL(url);
      if (u.searchParams.has('v')) {
        return u.searchParams.get('v');
      }
      if (u.hostname === 'youtu.be') {
        return u.pathname.slice(1);
      }
      if (u.pathname.includes('/embed/')) {
        return u.pathname.split('/embed/')[1];
      }
      return null;
    } catch {
      return null;
    }
  };

  const videoId = getYouTubeId(videoUrl);
  const embedUrl = videoId
    ? `https://www.youtube.com/embed/${videoId}`
    : '';

  return (
  <div className={styles.videoWrapper}
  style={
            !isLogicMaker
              ? {
                  position: 'fixed',
                  left: pos.x * window.innerWidth,
                  top: pos.y * window.innerHeight,
                  width: size.x * window.innerWidth,
                  height: size.y * window.innerHeight,
                }
              : {}
          } 
  >
    {embedUrl ? (
      <iframe
        className={`${styles.video} ${isDragging? styles.disablevideopointer:''}`}
       src={embedUrl}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={`YouTube video ${videoId}`}
      />
    ) : (
      <div className={styles.erro}>URL de vídeo inválida</div>
    )}
  </div>
);

};
